import { IncognitoCircleIcon } from './IncognitoCircleIcon';

/**
 * author: Google
 * id 80DE3C45-2A19-412F-9FA2-DCFB853F60ED
 * name incognito-circle
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/incognito-circle.svg
 * tags
 */
export const SpyCircleIcon = IncognitoCircleIcon;
export default SpyCircleIcon